



function bootstrapModal(ml, mle) {

    $(ml).modal(mle);
}

window.bootstrapModal = bootstrapModal;


export {bootstrapModal}
